import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { KycService } from '../../../../shared/services/kyc.service';
import { FaqCardModel } from '../../../partials/faq-card/faq-card.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { NgForm } from '@angular/forms';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  firstname: string;
  lastname: string;
  UserForm:NgForm;

  signupDetails = {
    firstname: '',
    lastname: ''
  };

  constructor( private router: Router,
    private api: KycService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit() {
  }
  

  faqQuestions: FaqCardModel = {
    title: 'Common Question',
    faqs: [
        {
            question: 'Welcome To Advisor',
            answer: 'We are offering you free money :D',
        },
        {
            question: 'Welcome To Advisor',
            answer: 'We are offering you free money :D',
        },
        {
            question: 'Welcome To Advisor',
            answer: 'We are offering you free money :D',
        },
        {
            question: 'Welcome To Advisor',
            answer: 'We are offering you free money :D',
        },
    ],
};

  submit(){
   
      this.spinner.show()
      console.log(this.signupDetails.firstname, this.signupDetails.lastname)
      this.api.onboard(this.signupDetails.firstname, this.signupDetails.lastname,'ADVISORY')
      .subscribe((res:any)=>{
        if (res.success === true){
          this.router.navigate(['/onboarding/menu']);
          this.spinner.hide();
        }  
        else{
          this.spinner.hide();
          this.toastr.error('Something went wrong',' Please try again',{
            timeOut:5000,
            positionClass: 'toast-top-center'
            
        });
        }
      },err=>{
        this.api.createAccount(this.signupDetails.firstname, this.signupDetails.lastname,'ADVISORY')
        .subscribe((res:any)=>{
          if (res.success == true){
            this.router.navigate(['/onboarding/menu']);
            this.spinner.hide();
          }
          else{
            this.spinner.hide();
            this.toastr.error('Please ensure you are submitting a correct info',' Please try again',{
              timeOut:5000,
              positionClass: 'toast-top-center'
              
          });
          } 
        },error =>{
          this.spinner.hide();
          this.toastr.error(err.error.message,' Please try again',{
            timeOut:5000,
            positionClass: 'toast-top-center'
            
        });
        }) 
       
      })
    
    
  }

}
